module.exports = __webpack_public_path__ + "media/pdfs/PrepWorks-Roadmap-To-Ivy-Leagues_Theme-Your-College-Application-541365d3fdb1da874a5abc4f8ba15ee8.pdf";